module.exports = __webpack_public_path__ + "static/elevation-shadows-do-bca96d36860d029085b2fe4230dc64ab.png";